<template>
  <div id="order-list">
    <div class="container">
      <el-button
        type="default go-to-invoice-manage"
        :class="{ 'go-right': !User.isAdminRole() && !User.isFinanceRole() }"
        v-if="User.peer && User.peer.invoice_status"
        @click="goToInvoiceManage()"
      >开发票</el-button>
      <el-button
        type="default show-all-order"
        v-if="User.isAdminRole() || User.isFinanceRole()"
        @click="goToAdminOrder()"
      >查看本店全部订单</el-button>
      <el-tabs v-model="tabActive" type="card" @tab-click="queryData(1, true)">

        <el-tab-pane label="签证" name="order">
          <template>
            <!-- 搜索栏 -->
            <el-form :model="queryParams" label-width="75px" :inline="true" class="search">

              <el-select v-model="queryParams.order_status" @change="changeFilter('visaorders_orderstates')" clearable placeholder="订单状态" class="search-common-w">
                <el-option v-for="(v,k) in $maps.ORDER_STATUS" :label="v" :key="k" :value="k.toString()">
                </el-option>
              </el-select>

              <el-select v-model="queryParams.applicant_status" @change="changeFilter('visaorders_applicantstates')" clearable placeholder="申请人状态" class="search-date">
                <el-option v-for="(v,k) in $maps.APPLICANT_STATUS" :label="v" :key="k" :value="k.toString()">
                </el-option>
              </el-select>

              <el-select v-model="queryParams.order_review_status" @change="changeFilter()" clearable placeholder="评价状态" class="search-date">
                <el-option v-for="item in evaluationStatus" :label="item.value" :key="item.id" :value="item.id">
                </el-option>
              </el-select>

              <el-date-picker class="search-date" v-model="go_date" type="daterange" range-separator=" ~ " :editable="false" @change="changeFilter('visaorders_paytime')" placeholder="支付时间">
              </el-date-picker>

              <div class="search-row">
                <el-select v-model="queryParams.order_type_id" clearable placeholder="订单类型" class="search-common-w">
                  <el-option v-for="(v,k) in $maps.ORDER_TYPE" :label="v" :key="k" :value="k">
                  </el-option>
                </el-select>

                <el-input  v-on:keyup.native.enter="changeFilter('visaorders_search')" class="search-condition" v-model="queryParams.condition" placeholder="订单号、申请人姓名、收件人手机号、商品名称、飞猪订单编号等">
                </el-input>

                <el-button type="primary" @click="changeFilter('visaorders_search')">查询</el-button>
                <el-button @click="queryData(1,true)">重置</el-button>
              </div>

            </el-form>

            <!-- 订单栏 -->
            <div class="list-box">
              <!-- 订单导出按钮 -->
              <div class="export-btn-box" v-if="showOtaOrders || orderList.length">
                <export-btn text="导出到本地" @exportFn="exportOrderList"></export-btn>
              </div>

              <!-- 飞猪订单列表 -->
              <fliggy-orders v-if="showOtaOrders" :condition="fliggyParams.condition" :isFilterOtaOrders="isFilterOtaOrders" :peer="peer"></fliggy-orders>

              <div class="list-item" v-for="(item, index) in orderList" :key="index">
                <!-- 顾客新订单标签 -->
                <img v-if="item.is_new_order" class="customer-new-tag" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/price/icon-order-new.png" alt="">

                <div class="list-title">
                  <div class="title-num">{{item.user_order_id}}</div>
                  <div class="title-name">{{item.product_name}}</div>
                  <div class="title-right">
                    <div class="title-status" :class="calculateOrderStatusClass(item, 1)">{{$maps.ORDER_STATUS[item.order_status]}}</div>

                    <order-invoice-tag :order="item"></order-invoice-tag>
                    
                    <button-more
                      class="m-r-30"
                      :order="item"
                      :order-list="orderList"
                      :index="index"
                    ></button-more>

                    <el-button type="default" v-if="(item.order_status > 0 && item.order_status < 4) || item.order_status === 10" @click="cancelOrder(item)">取消订单</el-button>

                    <el-button type="default" v-if="item.order_status === 0" @click="deleteOrder(item,index)">删除订单</el-button>
                  
                    <a class="el-button el-button--primary" v-if="item.order_status == 1" @click="goBuyingForMta(item)">上传资料</a>

                    <a class="el-button el-button--primary" v-if="item.order_status == 2" @click="goBuyingForMta(item)">填写申请表</a>

                    <a class="el-button el-button--primary" v-if="item.order_status == 3" @click="goBuyingForMta(item)">立即支付</a>

                    <a class="el-button el-button--primary" v-if="item.order_status == 10" @click="goBuyingForMta(item)">选择赴馆日期</a>

                    <el-button type="default" v-if="item.need_review" @click="goToEvaluate(item)">服务评价</el-button>

                    <!-- 以上是支付前的状态，以下是支付后的状态 -->
                    <a class="el-button el-button--danger" v-if="item.need_pay_price_diff === 1" @click="goToOrderDiffPay(item)">补缴费用</a>

                    <el-button type="danger" @click="delivery(item)" v-if="item.visa_supplier_id !== 0 && item.order_status === 4 && ( !item.pickup_status || item.pickup_status === 0 ) && item.need_pay_price_diff !== 1">寄送资料</el-button>

                    <a class="el-button el-button--primary" v-if="item.order_status > 3 && item.order_status !== 10" @click="goOrderDetail(item)">查看订单</a>

                    <a class="el-button el-button--primary" v-if="item.apply_by" @click="reOrder(item)">重新预约缴费</a>

                  </div>
                </div>
                <div class="order-applicant-box">
                  <div v-if="item.peer_user && item.peer_user.mobile_phone" class="user-phone">
                    <img class="icon" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/product/product/product-detail/price/icon-phone.png" alt="">
                    <div class="user-phone-label">顾客联系方式：</div>
                    <base-text-copy :text="item.peer_user.mobile_phone"></base-text-copy>
                  </div>
                  <!-- 申请人 -->
                  <template v-for="(ins, ind) in item.applicant">
                    <div class="insurant-list" :class="{'no-bottom-border': (ind === item.applicant.length - 1) || (!item.isExpand && ind === 2)}" v-if="item.isExpand || ind < 3" :key="ind">
                      <div class="insurant-list-left">
                        <div class="insurant-name-code-box">
                          <div class="insurant-name" >{{ins.applicant_name}}</div>
                          <div class="insurant-code">{{ins.identity}}</div>
                        </div>
                        <div class="insurant-status" :class="calculateApplicantStatusClass(ins, 1)">{{item.pay_time?$maps.APPLICANT_STATUS[ins.applicant_status]:''}}</div>
                        
                      </div>
                    </div>
                  </template>
                   <!-- 是否展开 -->
                  <expand :default-length="3" :max-length="item.applicant.length"  @expanded="expanded('order', index, $event)" />
                </div>
                <!-- 底部信息 -->
                <div class="list-bottom" v-if="item.pay_time || item.ota_info">
                  <div class="bottom-info-item" v-if="item.ota_info">
                    <fliggy-order-info-bar :ota-info="item.ota_info"></fliggy-order-info-bar>
                  </div>

                  <div class="bottom-info-item" v-if="item.pay_time && [0,1].indexOf(item.visa_status) > -1">
                    <div class="visa-date" v-if="item.visa_status === 0">
                      <span class="info-item-label">预计出签：</span>

                      <span v-if="!item.visa_date">
                        {{item.need_delivery > 0 || item.need_interview > 0 ? '预约成功后即可预估出签时间' : '送签后即可预估出签时间'}}
                      </span>
                      <span class="schedule-date-toggle" v-else>
                        {{item.visa_date}}{{ item.visa_date_longest && item.visa_date !== item.visa_date_longest ? `~${item.visa_date_longest}` : '' }}
                      </span>
                    </div>
                    <div class="visa-date" v-if="item.visa_status === 1">
                      <div class="schedule-item-date">
                        <span class="schedule-date-text">出签时间：</span>
                        <span class="schedule-date-toggle">
                          {{item.visa_date}}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="bottom-info-item" v-if="item.pay_time">
                    <span>支付时间：</span>
                    <span>
                      {{item.pay_time ? item.pay_time : '未支付'}}
                    </span>
                  </div>
                </div>
              </div>

            </div>

            <el-pagination v-if="orderList.length && tabActive === 'order'" class="page-box" @current-change="queryData" :current-page="page" :page-size="10" layout="prev, pager, next" :total="orderTotalCount">
            </el-pagination>
          </template>
          <div class="no-order" v-if="!orderList.length">
            <img src="../assets/imgs/order/no_order.png" alt="">
            <div>这里空荡荡，即刻开启上上签的全新办签体验~</div>
            <button @click="$router.push({name: 'countries'})">查看签证商品</button>
          </div>

        </el-tab-pane>

        <el-tab-pane label="保险" name="insurance" v-if="!User.is_palmyou">
          <template>
            <!-- 搜索栏 -->
            <el-form :model="queryParams" :inline="true" class="search insurance-box">
              <div class="insurance-warn">保险由第三方提供，如需开具发票，请联系客服电话 400-678-8169</div>
              <el-select v-model="queryParams.order_status" @change="queryData()" clearable placeholder="订单状态" class="search-common-w">
                <el-option v-for="(v,k) in $maps.INSURANCE_STATUS" :label="v" :key="k" :value="k.toString()">
                </el-option>
              </el-select>

              <el-date-picker class="search-date" v-model="go_date" type="daterange" range-separator=" ~ " :editable="false" @change="queryData()" placeholder="支付时间">
              </el-date-picker>

              <div class="search-row">
                <el-input class="search-condition" :maxlength="15" v-model="queryParams.condition" placeholder="投保单号、被保人姓名">
                </el-input>

                <el-button type="primary" @click="queryData()">查询</el-button>
                <el-button @click="queryData(1,true)">重置</el-button>
              </div>

            </el-form>

            <!-- 订单栏 -->
            <div class="insurance-list-box">
              <div class="list-item" v-for="(item, index) in insuranceList" :key="index">
                <!-- 订单顶部 -->
                <div class="list-title">
                  <div class="title-num">{{item.insurance_id}}</div>
                  <div class="title-name">{{item.insurance_name}}</div>
                  <div class="title-right">
                    <div class="title-status" :class="calculateOrderStatusClass(item, 2)">{{$maps.INSURANCE_STATUS[item.order_status]}}</div>
                    <el-button v-if="item.order_status === 3" @click="insuranceOrderAction(item, 1)">删除订单</el-button>
                    <el-button v-if="item.order_status === 0 " @click="insuranceOrderAction(item, 0)">取消订单</el-button>
                    <el-button v-if="![0,1].includes(item.order_status) && item.insurants.some(ap=>ap.insurant_status === 1)" @click="cancelInsuranceOrder(item)">取消订单</el-button>
                    <el-button v-if="item.order_status === 2" @click="downloadInsuranceOrder(item)" class="is-plain" type="primary" :loading="isDownloading">下载保单</el-button>
                    <!-- 非被保人本人投保，显示原逻辑 -->
                    <template v-if="!item.is_self_insure">
                      <a class="el-button el-button--primary" v-if="item.order_status === 1 || item.order_status === 2" type="primary" target="_blank" :href="item.insure_detail">查看订单</a>
                    </template>
                    <router-link class="el-button el-button--primary" v-if="item.order_status === 0" :to="{name:'insurancePay', query: {insuranceId: item.insurance_id}}">立即支付</router-link>
                  </div>
                </div>

                <div class="applicant-list">
                  <div class="applicant-item" v-for="(insurant, index) in item.isExpand ? item.insurants : item.insurants.slice(0, 3)" :key="index">
                    <div class="applicant-name">{{insurant.name}}</div>
                    <div class="applicant-code">{{insurant.card_code}}</div>
                    <div class="applicant-status">
                      <!-- insurant.insurant_status 之后加 用这个之前为啥没用 -->
                      <span v-if="insurant.insurant_status === 2">已生效</span>
                      <span class="red" v-if="insurant.insurant_status === 4">退保成功</span>
                    </div>
                    <div class="btn-list" v-if="item.is_self_insure">
                      <!-- <a class="btn" @click="downloadInsuranceOrder(insurant)" v-if="item.order_status === 2">下载保单</a> -->
                      <a class="btn" target="_blank" :href="insurant.insure_detail" v-if="item.order_status === 1 || item.order_status === 2">查看订单</a>
                    </div>
                  </div>
                </div>
                <!-- 是否展开 -->
                <expand :default-length="3" :max-length="item.insurants.length"  @expanded="expanded('insurance', index, $event)" />

                <!-- 底部信息 -->
                <div class="insurance-bottom">
                  <div class="bottom-left">
                    <div class="list-pay-price" v-if="item.pay_time && item.pay_amount">
                      <span class="list-label">支付金额</span>
                      <span class="list-value">
                        ￥{{item.pay_amount | price}}
                      </span>
                    </div>

                    <div class="list-paytime">
                      <span class="list-label">支付时间</span>
                      <span class="list-value">
                        {{item.pay_time ? item.pay_time : '未支付'}}
                      </span>
                    </div>
                  </div>

                  <div class="list-insure-time">
                    <span>保障期限 </span>
                    <span>{{moment(item.start_date).format('YYYY年M月D日')}} 至 {{moment(item.end_date).format('YYYY年M月D日')}}</span>
                  </div>
                </div>
              </div>
            </div>

            <el-pagination v-if="insuranceList.length && tabActive === 'insurance'" class="page-box" @current-change="queryData" :current-page="page" :page-size="10" layout="prev, pager, next" :total="insuranceTotalCount">
            </el-pagination>
          </template>
          <div class="no-order" v-if="!insuranceList.length">
            <img src="../assets/imgs/order/no_insurance.png" alt="">
            <div>这里空荡荡，试试给顾客推荐保险吧~</div>
            <button @click="$router.push({name: 'insurances'})">查看保险商品</button>
          </div>

        </el-tab-pane>

      </el-tabs>

    </div>

    <!-- 寄送资料 -->
    <express-type-choose :orderId="slOrder.user_order_id" :expressChooseModal="expressChooseModal" @modalClose="expressChooseModalClose"></express-type-choose>
    <!-- 取消订单 -->
    <cancel-reason :order="curCancelOrder" @cancelOrder="getData" v-model="cancelReasonModal"></cancel-reason>
    <!-- 取消保险订单 -->
    <cancel-insurance :order="cancelInsuranceInfo.currentInsuranceOrder" @refresh="getData" v-model="cancelInsuranceInfo.cancelInsuranceModal"></cancel-insurance>
  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import moment from 'moment';
import utils from '../libs/utils';
import Http from '../libs/http';
import dateUtils from '../libs/date-util';

import User from '../libs/user';
import insuranceApi from '../api/insurance-api';
import validates from '../libs/validates';
import expressTypeChoose from '../components/express-type-choose';
import expand from '../components/common/expand';
import fliggyOrders from '../components/ota/fliggy-orders';
import orderService from '../services/order-service';
import cancelReason from '../components/order-list/cancel-reason';
import cancelInsurance from '../components/order-list/cancel-insurance';
import OrderInvoiceTag from '../components/order-list/order-invoice-tag.vue';
import ExportBtn from '@/components/common/export-btn.vue';
import { ORDER_ENABLE_API_MAP } from '@/maps/order-maps';
import FliggyOrderInfoBar from '@/components/ota/fliggy-order-info-bar.vue';
import ButtonMore from './ordering/components/button-more.vue';
import BaseTextCopy from '@/components/common/base-text-copy.vue';

export default {
  name: 'orders',
  data() {
    return {
      tabActive: this.$route.query.tab || 'order', // 当前显示的tab
      insuranceList: [], // 保险订单数组
      insuranceTotalCount: 0,
      orderList: [], // 签证订单数组
      orderTotalCount: 0,
      User,
      evaluationStatus: [
        {
          id: 0,
          value: '待评价',
        },
        {
          id: 1,
          value: '已评价',
        },
      ],
      peer: User.peer || {},
      queryParams: {
        // 查询条件对象
        order_status: '',
        begin_date: '',
        end_date: '',
        applicant_status: '',
        condition: '',
        page: 1,
        // ota_id: '',
        m: new Date().getTime(),
        order_review_status: '',
        order_type_id: '',
      },
      fliggyParams: {
        condition: '',
      },
      page: 1,
      insurancePage: 1,
      slOrder: {},
      expressModal: false,
      expressChooseModal: false,
      express: {
        express_name: '',
        tracking_number: '',
      },

      rules: {
        express_name: [
          { required: true, message: '请输入正确的快递单号', trigger: 'change' },
        ],
        tracking_number: [
          validates.required(),
          {
            pattern: /^[0-9a-zA-Z]+$/,
            message: '请输入正确的快递单号',
            trigger: 'blur',
          },
        ],
      },
      isDownloading: false,
      otaStoreList: [], // 飞猪店铺list
      cancelReasonModal: false, // 取消订单原因弹窗
      curCancelOrder: null, // 当前要取消的订单
      cancelInsuranceInfo: {
        currentInsuranceOrder: null, // 当前要取消的保险订单
        cancelInsuranceModal: false,
      },
    };
  },
  components: {
    expressTypeChoose,
    fliggyOrders,
    expand,
    cancelReason,
    OrderInvoiceTag,
    ExportBtn,
    FliggyOrderInfoBar,
    cancelInsurance,
    ButtonMore,
    BaseTextCopy,
  },
  computed: {
    go_date: {
      get() {
        return this.queryParams.begin_date && this.queryParams.end_date
          ? [this.queryParams.begin_date, this.queryParams.end_date]
          : '';
      },
      set(nv) {
        this.queryParams.begin_date = nv ? nv[0] : '';
        this.queryParams.end_date = nv ? nv[1] : '';
      },
    },
    // 是否展示飞猪订单
    // 仅在第一页并且有店铺启用的时候
    showOtaOrders() {
      return (
        this.otaStoreList.some(item => item) &&
        this.page === 1
      );
    },
    // 当使用了筛选的时候，飞猪模块直接展示搜索不到
    isFilterOtaOrders() {
      return (
        this.queryParams.order_status !== '' ||
        this.queryParams.applicant_status !== '' ||
        this.go_date !== '' ||
        this.queryParams.order_review_status !== ''
      );
    },
  },
  watch: {
    $route() {
      if (this.tabActive === 'order' || this.tabActive === 'insurance') {
        this.orderList = [];
        this.insuranceList = [];
        this.getData();
      }
    },
  },
  methods: {
    moment,
    expanded(type, index, value) {
      if (type === 'order') {
        const obj = this.orderList[index];
        obj.isExpand = value;
        this.$set(this.orderList, index, obj);
      } else if (type === 'insurance') {
        const obj = this.insuranceList[index];
        obj.isExpand = value;
        this.$set(this.insuranceList, index, obj);
      }
    },
    changeFilter(eventName) {
      MtaH5.clickStat(eventName);
      this.queryData();
    },

    // 跳转至重新预约缴费页面
    reOrder(order) {
      // 获取重新预约缴费的申请人的订单id数组
      const applicantIdsToChange = order.applicant
        .filter(item => item.interview_status === 2)
        .map(item => item.order_applicant_id);
      this.$router.push({
        name: 'reOrderPay',
        params: { oid: order.user_order_id },
        // 传递申请人数组（先转化为string）
        query: {
          aidArray: JSON.stringify(applicantIdsToChange),
          updateDateType: 2, // 1为修改赴馆时间，2为重新预约缴费
        },
      });
    },

    // 切换是否展示更多
    toggleExpand(order) {
      order.isExpand = !order.isExpand;
    },

    goToInvoiceManage() {
      this.$router.push({ name: 'invoiceManage' });
    },

    // 跳转管理员查看订单
    goToAdminOrder() {
      this.$router.push({ path: '/admin-order' });
    },

    // 删除了ota订单
    deletedOtaOrder(otaOrderId) {
      this.otaOrderList = this.otaOrderList.filter(
        order => order.ota_order_id !== otaOrderId,
      );
      if (this.otaOrderList.length < 10) {
        this.getOtaOrders();
      }
      utils.msg.success('删除成功');
    },
    // 下载保单
    downloadInsuranceOrder(insurant) {
      if (!this.isDownloading) {
        this.isDownloading = true;
        insuranceApi
          .insuranceDownload({ insurance_num: insurant.insurance_num })
          .then((data) => {
            window.location.href = data.file_url;
            this.isDownloading = false;
          })
          .catch(() => {
            this.isDownloading = false;
          });
      }
    },

    // 删除保险订单
    insuranceOrderAction(order, action) {
      const _this = this;
      let title = '';
      let content = '';
      const params = { insurance_id: order.insurance_id };
      if (action === 0) {
        title = '取消订单';
        content = '确定要取消订单吗？';
      } else if (action === 1) {
        title = '删除订单';
        content = '确定要删除此订单吗？';
      } else {
        return;
      }

      utils.msgbox
        .confirm(content, title, {
          confirmButtonText: '确定',
          cancelButtonText: '再想想',
          type: 'warning',
        })
        .then(() => {
          if (action === 0) {
            return insuranceApi.insuranceOrderCancel(params);
          } else if (action === 1) {
            return insuranceApi.insuranceOrderDelete(params);
          }
        })
        .then(() => {
          if (action === 0) {
            order.order_status = 3;
          } else if (action === 1) {
            _this.getData();
          }
        }).catch((e) => {
          if (e) console.log(e);
        });
    },
    // 取消保险订单
    async cancelInsuranceOrder(item) {
      sensorsdata.track('ElementClick', {
        pagefrom: 'PC',
        click_content: '保险-取消订单',
      });
      // 打开弹框
      this.cancelInsuranceInfo.currentInsuranceOrder = item;
      this.cancelInsuranceInfo.cancelInsuranceModal = true;
    },
    // 计算订单状态的样式
    calculateOrderStatusClass(order, mark) {
      const statusClass = ['gray-plane', 'red-plane'];
      if (mark === 1) {
        if ([0, 8].indexOf(order.order_status) > -1) {
          return statusClass[0];
        } else if ([1, 2, 3, 4, 10].indexOf(order.order_status) > -1) {
          return statusClass[1];
        }
      } else if (mark === 2) {
        if ([3].indexOf(order.order_status) > -1) {
          return statusClass[0];
        } else if ([0].indexOf(order.order_status) > -1) {
          return statusClass[1];
        }
      }
      return '';
    },

    // 计算申请人状态的样式
    calculateApplicantStatusClass(item, mark) {
      const statusClass = ['status-gray', 'status-red'];
      if (mark === 1) {
        if ([2, 5, 6, 8, 13, 17, 18].indexOf(item.applicant_status) > -1) {
          return statusClass[1];
        }
      } else if (mark === 2) {
        if ([2].indexOf(item.insurant_status) > -1) {
          return statusClass[0];
        } else if ([4].indexOf(item.insurant_status) > -1) {
          return statusClass[1];
        }
      }
      return '';
    },

    // 取消订单
    cancelOrder(od) {
      MtaH5.clickStat('orderlist0cancel');
      this.cancelReasonModal = true;
      this.curCancelOrder = od;
    },

    // 删除订单
    deleteOrder(order) {
      const _this = this;
      utils.msgbox
        .confirm('确定删除该订单？', '删除订单', {
          confirmButtonText: '　确定　',
          cancelButtonText: ' 取消 ',
          type: 'warning',
        })
        .then(() => {
          // 埋点
          MtaH5.clickStat('orderlist0delete');

          Http.post('/order_delete', {
            user_order_id: order.user_order_id,
          }).then(() => {
            _this.getData();
          }).catch((e) => {
            if (e) console.log(e);
          });
        })
        .catch((e) => {
          if (e) console.log(e);
        });
    },

    queryData(page, reset) {
      if (reset) {
        Object.keys(this.queryParams).forEach((k) => {
          this.queryParams[k] = '';
        });

        // 重置直接将滚动条置顶
        const box = document.querySelector('.order-container');
        if (box) {
          box.scrollTop = 0;
        }
      }


      this.queryParams.m = new Date().getTime();
      this.$set(this.queryParams, 'page', page || 1);
      const query = utils.extend({}, this.queryParams, { tab: this.tabActive });

      // 清除日期后会变为null，2.7.0的vue-router会报错,2.8.0版本会将日期对象format导致日期丢失
      // 之前在url上拼接的是日期对象字符串，现改为年月日字符串
      query.begin_date = !query.begin_date
        ? ''
        : new Date(query.begin_date).format('yyyy-MM-dd');
      query.end_date = !query.end_date
        ? ''
        : new Date(query.end_date).format('yyyy-MM-dd');

      this.$router.push({ path: '/orders', query });
    },

    getData() {
      this.page = Number(this.$route.query.page) || 1;

      utils.forEach(this.queryParams, (v, k) => {
        this.queryParams[k] = this.$route.query[k] || '';
      });

      // this.queryParams.ota_id = this.$route.query.ota_id
      //   ? +this.$route.query.ota_id
      //   : '';

      this.queryParams.order_review_status = (parseInt(this.$route.query.order_review_status, 10) === 0 || parseInt(this.$route.query.order_review_status, 10) === 1)
        ? parseInt(this.$route.query.order_review_status, 10)
        : '';

      this.queryParams.page = this.page;

      const p = this.queryParams;
      const condition = {
        begin_date: p.begin_date ? p.begin_date : undefined,
        end_date: p.begin_date ? p.end_date : undefined,
        order_status: p.order_status ? parseInt(p.order_status, 10) : undefined,
        applicant_status: p.applicant_status
          ? parseInt(p.applicant_status, 10)
          : undefined,
        page: p.page || 1,
        condition: p.condition ? p.condition : undefined,
        // ota_id: p.ota_id ? +p.ota_id : undefined,
        order_review_status: (parseInt(p.order_review_status, 10) === 0 || parseInt(p.order_review_status, 10) === 1) ? parseInt(p.order_review_status, 10) : undefined,
        order_type_id: p.order_type_id ? parseInt(p.order_type_id, 10) : undefined,
      };

      if (this.tabActive === 'order') {
        // 搜索的时候把search传入到飞猪组件里面
        this.fliggyParams.condition = this.queryParams.condition;

        Http.post('/order_brief_query', condition).then((data) => {
          if (data.page_data) {
            JSON.parse(JSON.stringify(data.page_data)).forEach((order, index) => {
              data.page_data[index] = order;
            });
          }
          this.orderList = data.page_data || [];
          this.orderTotalCount = data.total_count || 0;
        }).catch((e) => {
          if (e) console.log(e);
        });
        // this.getOtaOrders();
      } else if (this.tabActive === 'insurance') {
        insuranceApi.insuranceOrderBriefQuery(condition).then((data) => {
          if (data.page_data) {
            JSON.parse(JSON.stringify(data.page_data)).forEach(
              (insuranceOrder, index) => {
                data.page_data[index] = insuranceOrder;
              },
            );
          }
          this.insuranceList = data.page_data || [];
          this.insuranceTotalCount = data.total_count || 0;
        }).catch((e) => {
          if (e) console.log(e);
        });
      }
    },

    delivery(od) {
      orderService.pickUpCheck(od.user_order_id).then(() => {
        this.slOrder = od;
        this.expressChooseModal = true;
      });
    },

    // 关闭快递方式选择页触发时间
    expressChooseModalClose(orderId) {
      if (orderId) {
        this.orderList.forEach((order) => {
          if (order.user_order_id === orderId) {
            order.order_status = 5;
          }
        });
      }
      this.expressChooseModal = false;
    },

    expressAdd(od) {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          const postData = utils.extend({}, this.express, {
            user_order_id: od.user_order_id,
          });

          Http.post('/order_supplier_express_add', postData).then(() => {
            utils.msg.success('发货成功');
            od.order_status = 5;
            this.expressModal = false;
          }).catch((e) => {
            if (e) console.log(e);
          });
        }
      });
    },

    // 到订单详细界面
    goOrderDetail(order) {
      this.$router.push({
        name: 'orderDetail',
        params: { oid: order.user_order_id },
      });
    },

    // 根据不同状态到下单界面 同时加入埋点
    goBuyingForMta(item) {
      if (item.order_status === 1) {
        MtaH5.clickStat('orderlist0upload');
        this.$router.push({
          name: 'waittingForUpload',
          params: {
            oid: item.user_order_id,
          },
        });
      }
      if (item.order_status === 2) {
        MtaH5.clickStat('orderlist0fillform');
        this.$router.push({
          name: 'waittingForUpload',
          params: {
            oid: item.user_order_id,
          },
        });
      }
      if (item.order_status === 3) {
        MtaH5.clickStat('orderlist0paynow');
        this.$router.push({
          name: 'orderComfirm',
          params: {
            oid: item.user_order_id,
          },
        });
        // if (User.is_palmyou && item.business_order_id) {
        //   this.$router.push({
        //     name: 'payConfirm',
        //     params: {
        //       oid: item.user_order_id,
        //     },
        //     query: {
        //       typeid: 1,
        //       payPrice: item.pay_amount / 100,
        //     },
        //   });
        // } else {
        //   this.$router.push({
        //     name: 'orderComfirm',
        //     params: {
        //       oid: item.user_order_id,
        //     },
        //   });
        // }
      }
      if (item.order_status === 10) {
        MtaH5.clickStat('orderlist0selectembassy');
        this.$router.push({
          name: 'waittingForChooseInterviewTime',
          params: {
            oid: item.user_order_id,
          },
        });
      }
    },

    // 到补缴费用界面
    goToOrderDiffPay(item) {
      // 埋点
      MtaH5.clickStat('orderlist0payextra');

      this.$router.push({
        name: 'orderDiffPay',
        params: {
          oid: item.user_order_id,
        },
      });
    },

    // 去到订单评价界面
    goToEvaluate(item) {
      this.$router.push({
        name: 'orderEvaluation',
        params: {
          oid: item.user_order_id,
        },
      });
    },
    // 获取飞猪店铺list
    getOtaStoreList() {
      Http.post('/peer_ota_brief_query', {})
        .then((data) => {
          this.otaStoreList = data;
        });
    },

    formatDateWithoutYear: dateUtils.formatDateWithoutYear,

    // 订单导出
    async exportOrderList(callback = () => {}) {
      const params = {
        applicant_status: this.queryParams.applicant_status ? +this.queryParams.applicant_status : undefined,
        begin_date: this.queryParams.begin_date || undefined,
        condition: this.queryParams.condition || undefined,
        end_date: this.queryParams.end_date || undefined,
        order_review_status: [0, 1].includes(parseInt(this.queryParams.order_review_status, 10)) ? +this.queryParams.order_review_status : undefined,
        order_status: this.queryParams.order_status ? +this.queryParams.order_status : undefined,
        is_query_all: 0, //  0-查询订单列表下的导出 1-查看本店所有订单下的导出
      };

      try {
        const { total_data } = await Http.post('/order_export', params);
        let exportData = [];
        if (total_data) {
          exportData = total_data.map(item => ({
            ...item,
            enable_api: ORDER_ENABLE_API_MAP[item.enable_api],
            total_amount: item.total_amount / 100,
            pay_amount: item.pay_amount / 100,
            actual_pay_amount: item.actual_pay_amount / 100,
            discount_amount: item.discount_amount / 100,
          }));
        }
        callback(exportData, {
          user_order_id: '订单号',
          country: '商品目的地',
          product_name: '商品全称',
          total_amount: '订单总金额',
          pay_amount: '应支付金额',
          actual_pay_amount: '实付金额',
          discount_amount: '优惠金额',
          order_status_desc: '订单状态',
          enable_api: 'API订单', // 0 ,1 
          pay_time: '订单支付时间',
          applicant_name: '申请人',
          applicant_count: '申请人数量',
          applicant_status_desc: '申请人状态',
        }, `订单列表_${moment(new Date()).format('YYYYMMDDHHmmss')}.xlsx`);

      } catch (e) {
        callback(); // 防止按钮一直加载
        console.log(e);
      }
    },
  },
  created() {
    this.getData();
    this.getOtaStoreList();
    if (!User.peer) {
      Http.post('/visa_peer_query').then((data) => {
        this.peer = data;
        User.peer = data;
      }).catch((e) => {
        if (e) console.log(e);
      });
    }
  },
};
</script>

<style lang="less" scoped>
@import '../assets/less/variable';

#order-list {
  margin-top: 20px;
  margin-bottom: 95px;
  .container {
    position: relative;
    .show-all-order {
      color: @main;
      border-color: @main;
      position: absolute;
      right: 0;
      cursor: pointer;
      z-index: 10;
    }
    .go-to-invoice-manage {
      color: @main;
      border-color: @main;
      position: absolute;
      right: 152px;
      width: 90px;
      cursor: pointer;
      z-index: 10;
      &.go-right {
        right: 0;
      }
    }
  }
  .no-order {
    background-color: #ffffff;
    text-align: center;
    font-size: 14px;
    color: #6f6f6f;
    height: 454px;
    img {
      width: 140px;
      height: 100px;
      margin-top: 90px;
    }
    div {
      margin-top: 30px;
    }
    button {
      width: 200px;
      height: 34px;
      border: 0;
      color: #ffffff;
      background-color: #5e9be1;
      border-radius: 17px;
      margin-top: 20px;
    }
  }
  .search {
    padding: 20px;
    background-color: @color-eaf3ff;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    > div {
      margin-right: 20px;
      margin-bottom: 14px;
    }
    .search-row {
      width: 100%;
      display: flex;
      margin-bottom: 0;
    }
    .search-row > div {
      margin-right: 20px;
    }
    .search-condition {
      width: 750px;
    }
  }

  .search.insurance-box {
    padding-top: 56px;
    .insurance-warn {
      position: absolute;
      top: 0px;
      left: 0px;
      height: 36px;
      background-color: @color-fffac4;
      padding-left: 20px;
      line-height: 36px;
      color: @text-6f;
      font-size: 12px;
      width: 1000px;
    }
  }

  .list-box {
    padding: 20px;
    background-color: @white;
    .list-item {
      border: 1px #f0f0f0 solid;
      box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.08);
      font-size: 16px;
      margin-bottom: 24px;
      border-radius: 4px;
      position: relative;
      .customer-new-tag{
        width: 65px;
        height: 40px;
        position: absolute;
        top: -14px;
        left: -11px;
      }
      .list-title {
        display: flex;
        align-items: center;
        height: 56px;
        border-bottom: 1px solid @border;
        padding-left: 20px;
        justify-content: space-between;
        .title-right {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          flex-shrink: 0;
          > button,
          > span,
          > a {
            /* margin-left: 20px; */
            margin: 0 14px 0 0;
            padding: 0 12px;
            line-height: 28px;
            text-align: center;
            height: 30px;
          }
        }
        .title-num {
          padding: 0 12px;
          height: 30px;
          background-color: @bg;
          line-height: 30px;
          font-size: 14px;
          color: @text-sliver;
          text-align: center;
          margin-right: 15px;
          border-radius: 4px;
        }
        .title-name {
          color: @text-dark;
          font-weight: bold;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          flex: 1;
          padding-right: 100px;
        }
        .title-status {
          margin-right: 40px;
          flex-shrink: 0;
          padding-left: 24px;
          position: relative;
          font-size: 14px;
          color: @text-dark;
          &::before {
            content: '';
            position: absolute;
            left: 0px;
            top: 0px;
            width: 14px;
            height: 14px;
            background: url(../assets/imgs/insurance/status-common.png) center
              center no-repeat;
          }
          &.gray-plane {
            color: @text-aaa;
            &::before {
              background: url(../assets/imgs/insurance/status-cancel.png) center
                center no-repeat;
            }
          }
          &.red-plane {
            color: @text-red;
            &::before {
              background: url(../assets/imgs/insurance/status-process.png)
                center center no-repeat;
            }
          }
        }
      }

      .list-bottom {
        height: 40px;
        background-color: @active;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: @text-aaa;
        padding: 0 20px;
        .bottom-info-item{
          border-right: 1px solid #F0F0F0;
          display: flex;
          align-items: center;
          &:first-child{
            padding-left: 0;
          }
          &:last-child{
            border-right: none;
          }
        }
      }

      .list-expand {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 40px;
        margin-bottom: 20px;

        .expand-line {
          height: 1px;
          background-color: @border;
          width: 50%;
        }
        .expand-content {
          cursor: pointer;
          flex-shrink: 0;
          margin: 0 20px;
          padding-right: 22px;
          position: relative;
          font-size: 14px;
          color: @text-sliver;
          span {
            color: @blue;
          }
          &.is-expand {
            &::after {
              transform: rotate(180deg);
            }
          }
          &::after {
            content: '';
            position: absolute;
            right: 0px;
            top: 0px;
            width: 16px;
            height: 16px;
            background: url(../assets/imgs/insurance/insurance-expend-all.png)
              center center no-repeat;
          }
        }
      }

      .order-applicant-box{
        position: relative;
        .user-phone{
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          color: #5F666E;
          font-size: 12px;
          line-height: 1;
          width: 300px;
          height: 24px;
          background: linear-gradient( 270deg, rgba(89,159,255,0.08) 0%, rgba(89,159,255,0) 100%);
          padding: 0 20px;
          .icon{
            width: 12px;
            height: 12px;
            margin-right: 4px;
          }
          .user-phone-user{
            cursor: pointer;
            &:hover{
              color: #5E9BE2;
            }
          }
        }
      }

      .insurant-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 20px 0 40px;
        border-bottom: 1px dashed @border;
        .insurant-list-left{
          margin: 0 auto;
          height: 76px;
          width: 880px;
          display: flex;
          align-items: center;

          font-size: 16px;
          color: @text-dark;
        }
        &.no-bottom-border {
          border-bottom-color: transparent;
        }
        .insurant-name-code-box{
          width: 350px;
          display: flex;
          align-items: center;
        }
        .insurant-name {
          flex-shrink: 0;
          min-width: 100px;
          max-width: 100px;
          margin-right: 50px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .insurant-code {
          width: 100px;
          // margin-right: 100px;
          color: @text-aaa;
        }
        .insurant-status {
          &.status-red {
            color: @text-red;
          }
          &.status-gray {
            color: @text-aaa;
          }
        }
        .insurant-visa-date{
          margin-left: 8px;
          padding-left: 8px;
          height: 20px;
          border-left: 1px solid #F0F0F0;
          color: #aaa;
          font-size: 14px;
          display: flex;
          align-items: center;
          line-height: 1;
        }
      }
    }
  }

  .insurance-list-box{
    padding: 20px;
    background-color: @white;
    .list-item{
      border: 1px #f0f0f0 solid;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
      font-size: 16px;
      margin-bottom: 24px;
      border-radius: 2px;
      .list-title{
        height: 53px;
        display: flex;
        align-items: center;
        padding: 0 14px 0 20px;
        border-bottom: 1px solid #F0F0F0;
        .title-num{
          display: inline-flex;
          align-items: center;
          height: 30px;
          border-radius: 4px;
          background: #F7F8FA;
          padding: 0 12px;
          margin-right: 15px;
          color: #777777;
          font-size: 14px;
        }
        .title-name{
          color: #333333;
          font-size: 16px;
          font-weight: 600;
          flex-grow: 1;
          padding-right: 100px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .title-right{
          flex-shrink: 0;
          display: flex;
          align-items: center;
          .title-status {
            margin-right: 40px;
            flex-shrink: 0;
            padding-left: 24px;
            position: relative;
            font-size: 14px;
            color: @text-dark;
            &::before {
              content: '';
              position: absolute;
              left: 0px;
              top: 0px;
              width: 14px;
              height: 14px;
              background: url(../assets/imgs/insurance/status-common.png) center
                center no-repeat;
            }
            &.gray-plane {
              color: @text-aaa;
              &::before {
                background: url(../assets/imgs/insurance/status-cancel.png) center
                  center no-repeat;
              }
            }
            &.red-plane {
              color: @text-red;
              &::before {
                background: url(../assets/imgs/insurance/status-process.png)
                  center center no-repeat;
              }
            }
          }
          > button,
          > span,
          > a {
            /* margin-left: 20px; */
            margin: 0 14px 0 0;
            padding: 0 12px;
            line-height: 28px;
            text-align: center;
            height: 30px;
          }
        }
      }
      .applicant-list{
        padding: 0 28px 0 50px;
        .applicant-item{
          display: flex;
          align-items: center;
          border-bottom: 1px dashed #F0F0F0;
          height: 65px;
          &:last-child{
            border-bottom: none;
          }
          .applicant-name{
            width: 90px;
            color: #333333;
            font-size: 18px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .applicant-code{
            margin-left: 40px;
            color: #777777;
            font-size: 16px;
          }
          .applicant-status{
            margin-left: 40px;
            font-size: 16px;
            color: #333333;
            .red{
              color: #FF5A60;
            }
          }
          .btn-list {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            .btn {
              color: #599FFF;
              margin-left: 20px;
            }
          }
        }
      }
      .insurance-bottom {
        height: 43px;
        background-color: #FBFBFB;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        padding: 0 20px;
        .bottom-left{
          display: flex;
          align-items: center;
          .list-pay-price{
            display: flex;
            align-items: center;
            margin-right: 40px;
            position: relative;
            &::after{
              content: '';
              width: 1px;
              height: 20px;
              background: #F0F0F0;
              position: absolute;
              right: -20px;
              top: 50%;
              transform: translateY(-50%);
            }
            .list-label{
              color: #AAAAAA;
            }
            .list-value{
              color: #777777;
              margin-left: 8px;
            }
          }
          .list-paytime {
            display: flex;
            align-items: center;
            margin-right: 40px;
            position: relative;
            .list-label{
              color: #AAAAAA;
            }
            .list-value{
              color: #777777;
              margin-left: 8px;
            }
          }
        }
        .list-insure-time{
          color: #AAAAAA;
        }
      }
    }

  }

  .page-box {
    background-color: @white;
    text-align: center;
    padding-bottom: 40px;
  }
}
</style>
<style lang="less">
@import '../assets/less/variable';

#order-list {
  .el-tabs__header {
    margin-bottom: 0;
    border-bottom-color: @color-d3e4f8;
  }
  .el-tabs__item {
    background-color: @white;
    border-bottom-color: @color-d3e4f8;
    width: 140px;
    color: @text-sliver;
    text-align: center;
    font-size: 16px;
    &.is-active {
      border-color: @color-d3e4f8;
      border-bottom-color: @color-eaf3ff;
      background-color: @color-eaf3ff;
      color: @blue;
      font-weight: bold;
    }
  }

  .search {
    .el-select .el-input {
      width: 220px;
    }
    .el-button {
      width: 80px;
    }
    .search-date .el-input {
      width: 220px;
    }
    .search-common-w .el-input {
      width: 220px;
    }
    .el-button {
      margin: 0;
      margin-right: 20px;
    }
  }
}
.export-btn-box {
  margin-bottom: 20px;
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/pages/Orders.vue